module.exports = __webpack_public_path__ + "img/pic_subject_chemistry.dec43495.png";